import { EditProfileConstants } from "../constants/editProfile.constants";
import { createAction } from "redux-actions";

export const openProfile = createAction(EditProfileConstants.OPEN_PROFILE);
export const editProfile = createAction(EditProfileConstants.EDIT_PROFILE);
export const saveProfile = createAction(EditProfileConstants.SAVE_PROFILE);
export const closeProfile = createAction(EditProfileConstants.CLOSE_PROFILE);
export const saveProfileSuccess = createAction(
    EditProfileConstants.SAVE_PROFILE_SUCCESS
);
export const saveProfileFailure = createAction(
    EditProfileConstants.SAVE_PROFILE_FAILURE
);



// WEBPACK FOOTER //
// ./src/actions/editProfile.actions.js